import React from 'react'

const Club = () => {
    return (
        <div>
            <div className="cardContainer">
                <div className="myCard mt-5">
                    <div className="innerCard m-3">
                        <div className="frontSide m-3">
                            <p className="title">Total Clubs</p>
                            <span>9</span>
                        </div>
                        <div className="backSide">
                            <p className="title">
                                <img className='image' src="https://scontent.fktm3-1.fna.fbcdn.net/v/t39.30808-6/361882662_662429449246328_6078825569084641202_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=49d041&_nc_ohc=xEHm9akDjx8AX_K4yLT&_nc_ht=scontent.fktm3-1.fna&oh=00_AfDfgz7xSqJ-nkJFWf14ERAZ5JnLrhJ_n3CsicY1yoIZsA&oe=64F76BFA" alt="" />
                            </p>
                        </div>
                    </div>
                </div>


                <div className="myCard mt-5">
                    <div className="innerCard m-3">
                        <div className="frontSide m-3">
                            <p className="title">Total Community</p>
                            <span>2</span>
                        </div>
                        <div className="backSide">
                            <p className="title">
                                <img className='image' src="https://scontent.fktm3-1.fna.fbcdn.net/v/t39.30808-6/361877907_662429602579646_9089915276351130372_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=49d041&_nc_ohc=rOoCn-lSkiUAX9qj40B&_nc_ht=scontent.fktm3-1.fna&oh=00_AfBfRUs_D6T6eD8GSBt4NZLARn9xek2AFhPdPlBP4ivlIQ&oe=64F66BC8" alt="" />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Club
